/* eslint-disable */
import $ from 'jquery';
import _ from 'lodash';

const activeClass = 'is-active';
const hiddenClass = 'hidden';

class ToggleVisiblity {

    constructor() {

        this.$el = $('.js-toggle-visibility');

        if (!this.$el.length) {
            return;
        }

        this.$el.on('click', (event) => {

            const $trigger = $(event.currentTarget);
            const $target = this.getTarget($trigger);

            if (!$target) {
                return;
            }

            if ($target.hasClass(hiddenClass)) {
                this.show($target);
            } else {
                this.hide($target);
            }

        });

    }

    getTarget($el) {
        const target = $el.data('target');
        return $(target);
    }

    getTriggers($el) {
        const targetId = $el.attr('id');
        return this.$el.filter(`[data-target="#${targetId}"]`);
    }

    show($el) {

        const $triggers = this.getTriggers($el);

        $el.removeClass(hiddenClass);
        $triggers.addClass(activeClass);
    }

    hide($el) {

        const $triggers = this.getTriggers($el);

        $el.addClass(hiddenClass);
        $triggers.removeClass(activeClass);
    }

}

export default new ToggleVisiblity();
